import type NodeTransformerFunc from "@ext/markdown/core/edit/logic/Prosemirror/NodeTransformerFunc";
import { isBlockHtmlTag, isInlineHtmlTag } from "@ext/markdown/elements/htmlTag/edit/logic/isHtmlTag";
import HtmlTagToComponent from "@ext/markdown/elements/htmlTag/logic/htmlTagToComponent/htmlTagToComponent";
import type { JSONContent } from "@tiptap/core";

// An `<a>` without an address is a place to jump to, not a link: as a link mark it lives only on
// its own text, and an empty anchor has none.
const isAnchorTarget = (node: JSONContent) => node.attrs.name === "a" && !node.attrs.attributes?.href;

const htmlTagNodeTransformer: NodeTransformerFunc = (node) => {
	if (!isInlineHtmlTag(node.type) && !isBlockHtmlTag(node.type)) return null;

	const nodeTransformer = isAnchorTarget(node) ? null : HtmlTagToComponent[node.attrs.name];
	if (nodeTransformer) {
		const newNode = nodeTransformer(node);
		return { isSet: true, value: newNode };
	}

	node = {
		type: isInlineHtmlTag(node.type) ? "inlineHtmlTagComponent" : "blockHtmlTagComponent",
		attrs: { content: node },
	};
	return { isSet: true, value: node };
};

export default htmlTagNodeTransformer;
